import MyChecks from '@/views/Check/MyChecks'

const routes = {
  path: '/myChecks',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/myChecks',
      name: 'Meus pontos',
      component: MyChecks,
    },
  ],
}

export default routes
